import React, {useState} from 'react';
import { SafeAreaView } from 'react-native-safe-area-context';
import { Button, Divider, Layout, Text, Card, Icon, Menu, MenuItem, MenuGroup, IndexPath } from '@ui-kitten/components';
import { StyleSheet, View, Image, Dimensions, ScrollView, TouchableOpacity } from 'react-native';
import moment from 'jalali-moment'
import * as RootNavigation from '../../../root.navigation.js';
import trackerApi from '../../api/tracker';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { setTaskData } from '../../../store/actions/request';
import { useDispatch } from 'react-redux';
import { useIsFocused } from "@react-navigation/native";


const width = Dimensions.get('window').width;
const height = Dimensions.get('window').height;
const titles = ['پرداخت','تحویل','انصراف مشتری','سفارشات من','محصولات و خدمات']

const BackIcon = (props) => (
  <Icon {...props} name='arrow-forward-outline'
  style={[props.style, {width:30,height:30 }]}
  fill = '#417CBE'
  />
);

const NewTask = (props) => (
  <Icon {...props}
    style={[props.style, {width:36,height:36 }]}
    fill = '#417CBE'
    name='alert-circle'/>
);
const Eye = (props) => (
  <Icon {...props}
    style={[props.style, {width:36,height:36 }]}
    fill = '#417CBE'
    name='eye'/>
);

const QuestionIcon = (props) => (
  <Icon {...props} name='question-mark'/>
);

const BrowserIcon = (props) => (
  <Icon {...props} name='browser-outline'/>
);

const ColorPaletteIcon = (props) => (
  <Icon {...props} name='color-palette-outline'/>
);
const Flag = (props) => (
  <Icon {...props}
    style={[props.style, {width:36,height:36 }]}
    fill = '#417CBE'
    name='flag'/>
);
const Flash = (props) => (
  <Icon {...props}
    style={[props.style, {width:36,height:36 }]}
    fill = '#417CBE'
    name='flash'/>
);

const AnswerIcon = (props) => (
  <Icon {...props} name='book-open'/>
);

const ForwardIcon = (props) => (
  <Icon {...props} name='arrow-ios-back'/>
);
const CardIcon = (props) => (
  <Icon {...props} name='credit-card'/>
);
const DeliveryIcon = (props) => (
  <Icon {...props} name='shopping-bag'/>
);
const CancelIcon = (props) => (
  <Icon {...props} name='person-delete'/>
);
const MyOrderIcon = (props) => (
  <Icon {...props} name='briefcase'/>
);
const ProductsIcon = (props) => (
  <Icon {...props} name='cube'/>
);
export const Faq = ({ navigation }) => {
  const isVisible = useIsFocused();
  const [selectedIndex, setSelectedIndex] = React.useState(new IndexPath(0));
  const [selectedQIndex, setSelectedQIndex] = React.useState(null);
  const [data, setData] = React.useState([]);
  const dispatch = useDispatch();
  const getData = async ()=>{
    const token =  await AsyncStorage.getItem('userId');
    const response = await trackerApi.get('/faq/data',null, {
      headers: {Authorization: `Bearer ${token}`}
    });
    setData(response.data.allData);
    console.log(response.data.allData);
  }

  React.useEffect(()=>{
    getData()
  },[isVisible])
  const titles = ['پرداخت','تحویل','انصراف مشتری','سفارشات من','محصولات و خدمات']
  console.log(selectedIndex);
  return (
    <Layout level='2' style={{flex:1}}>
    <SafeAreaView>
    <Layout level='2' style={{flexDirection:'row', alignItems:'center',marginBottom:10, justifyContent:'space-between'}}>
    <TouchableOpacity style={{marginHorizontal:15, marginTop:10}} onPress={()=> RootNavigation.navigate('profile')}>
    <BackIcon />
    </TouchableOpacity>
    <Layout level='2' style={{alignItems:'center', justifyContent:'space-between'}}>
    <Text status='primary' style={{marginTop:20, marginBottom:5, textAlign:'center'}}>دسته بندی</Text>

    </Layout>
    <Layout level='2' style={{marginHorizontal:15, width:24}}/>
    </Layout>
    <ScrollView>
      <Menu
        selectedIndex={selectedIndex}
        onSelect={index => setSelectedIndex(index)}>
        <MenuItem
          title='پرداخت'
          accessoryLeft={CardIcon}
        />
        <MenuItem
          title='تحویل'
          accessoryLeft={DeliveryIcon}
        />
        <MenuItem
          title='انصراف مشتری'
          accessoryLeft={CancelIcon}
        />
        <MenuItem
          title='سفارشات من'
          accessoryLeft={MyOrderIcon}
        />
        <MenuItem
          title='محصولات و خدمات'
          accessoryLeft={ProductsIcon}
        />
      </Menu>

      <Text status='primary' category='h6' style={{marginTop:15, marginBottom:10, textAlign:'center'}}>سوالات پر تکرار</Text>
        <Menu
            style={{marginHorizontal:15}}
            selectedIndex={selectedQIndex}
            onSelect={index => setSelectedQIndex(index)}>
            { data ? data.map((item, index) => {
            if(item.title ==  titles[selectedIndex.row]){
            return( <MenuGroup title={item.question} accessoryLeft={QuestionIcon}>
              <MenuItem disabled title={item.answer} accessoryLeft={AnswerIcon}/>
            </MenuGroup>)
            }
          }) : null
          }

        </Menu>
          </ScrollView>
    </SafeAreaView>

    </Layout>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    flexWrap: 'wrap',
  },
  card: {
    marginHorizontal: 15,
    marginVertical: 8,
    color:'#5469215'
  },
  cardLayout:{
    flexDirection:'row',
    justifyContent:'space-between',
  },
  rightContainer:{
    flex:1,
    alignItems:'flex-start'
  },
  leftContainer:{
    alignItems:'flex-end'
  },
  centerContainer:{
    flex:2,
    alignItems:'flex-start'
  },
});
